import { Skeleton } from '@mui/material';

interface StepSkeletonProps {
    showHeader?: boolean;
    cardsCount?: number;
    showFooter?: boolean;
}

const StepSkeleton = ({ 
    showHeader = true, 
    cardsCount = 2,
    showFooter = false 
}: StepSkeletonProps) => {
    return (
        <>
            {/* Header skeleton */}
            {showHeader && (
                <>
                    <div className='self-stretch inline-flex justify-start items-center gap-2.5'>
                        <Skeleton variant="circular" width={16} height={16} />
                        <Skeleton width={120} height={24} />
                    </div>
                    <div className='self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-[#e5e5e5]' />
                </>
            )}

            {/* Subtitle skeleton */}
            <div className='self-stretch flex-col gap-2 mb-4'>
                <Skeleton width="80%" height={20} />
            </div>

            {/* Cards skeleton */}
            <div className='self-stretch flex flex-col gap-4'>
                {Array.from(new Array(cardsCount)).map((_, index) => (
                    <Skeleton
                        key={index}
                        variant="rectangular"
                        width="100%"
                        height={46}
                        sx={{ borderRadius: 2 }}
                    />
                ))}
            </div>

            {/* Footer totals skeleton */}
            {showFooter && (
                <div className='w-full space-y-2 mt-4'>
                    <div className='flex justify-between items-center w-full'>
                        <Skeleton width="30%" height={20} />
                        <Skeleton width="20%" height={20} />
                    </div>
                    <div className='flex justify-between items-center w-full'>
                        <Skeleton width="30%" height={20} />
                        <Skeleton width="20%" height={20} />
                    </div>
                </div>
            )}
        </>
    );
};

export default StepSkeleton; 